<template>
      <field-form  id="pfid1619368033" v-if="item" @save="$emit('save')" :saving="saving" :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep" :last-editable-step="lastEditableStep" :allow-editable="true" @cancel="cancelWizard()" @click-step="changeStep">
      <!--
      <v-row no-gutters class="mb-5" v-if="wizard" align="center">
      <wizard-stepper id="pfid1618819277" :steps="currentWizard" class="flex-grow-1 flex-shrink-1" :step="displayStep" :allow-editable="true" :last-editable-step="lastEditableStep" @click-step="changeStep" />
      <v-btn large class="pfcl1618819249 mx-5" @click="cancelWizard"><v-icon left>$close</v-icon>{{$t('form.cancelWizard')}}</v-btn>
      <v-btn :loading="refreshing" id="pfid1619366167" large class="mr-5" @click="refresh"><v-icon left>$refresh</v-icon>{{ $t('common.refresh') }}</v-btn>
      <v-btn id="pfid1619366263"  large class="mr-5" @click="nextStep">{{ $t('form.next') }}<v-icon right>$next</v-icon></v-btn>
    </v-row>
    -->
    <v-row no-gutters class="mb-3" xjustify="space-between" align="center">
    <h2 class="text-h4">{{$t('tracking.title')}}</h2>
    <v-spacer />
    <action-button @click="$emit('copyOpen', item.id)" icon="$copy" :tooltip="$t('tracking.copyOpen')" color="primary" fab small dark />
    <action-button button-class="mx-1" @click="$emit('mailOpen', item.id)" icon="$mailing" :tooltip="$t('tracking.mailOpen')" color="primary" fab small dark />
    <action-button @click="refresh" :loading="refreshing" icon="$refresh" :tooltip="$t('common.refresh')" color="primary" fab small dark />
    </v-row>
    <p v-html="$t('tracking.text')"></p>
    <v-expansion-panels class="mb-3" accordion multiple v-model="model">
    
    <v-expansion-panel>
      <v-expansion-panel-header>
        <span><v-icon left>$settings</v-icon> {{$t('tracking.platformSettings.title')}} <tooltip-icon right :icon="platformSettingsState.icon" :color="platformSettingsState.color" :tooltip="platformSettingsState.text" /></span>
      </v-expansion-panel-header>
      
      <v-expansion-panel-content>
        <!--
        <template v-if="item.platform != platform">
          <field-form buttonText="Switch project to this platform" @save="prepareSwitch"/>
            <confirm-dialog v-model="switchWarning" @confirm="save" button-caption="Switch platform">
              This operation will change tracking parameters to suit the new platform and temporarily deactivates the tracking to check the correct implementation of the tracking codes. Are you sure you want to continue?
            </confirm-dialog>
        </template>
        <slot v-else name="platformSettings" :fail="platformSettingsState.fail" :text="platformSettingsState.text" :id="item.id">
            <v-icon :color="platformSettingsState.color" left>{{ platformSettingsState.icon }}</v-icon><span>{{ platformSettingsState.text }}</span>
        </slot>
        -->
        <slot name="platformSettings" :fail="platformSettingsState.fail" :text="platformSettingsState.text" :id="item.id">
            <v-icon :color="platformSettingsState.color" left>{{ platformSettingsState.icon }}</v-icon><span>{{ platformSettingsState.text }}</span>
        </slot>
      </v-expansion-panel-content>
    </v-expansion-panel>
    
    <template v-for="(v,k) in panels" >
    <v-expansion-panel :key="k" v-if="!!$slots[k] || !!$scopedSlots[k]">
      <v-expansion-panel-header>
        <span><v-icon left>{{v.icon}}</v-icon> {{ v.text }} <tooltip-icon right :icon="getCapabilityIcon(k)" :color="getCapabilityColor(k)" :tooltip="getCapabilityText(k)" /></span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <slot :name="k" :fail="getCapabilityFail(k)" :text="getCapabilityText(k)" :id="item.id" />
      </v-expansion-panel-content>
    </v-expansion-panel>
    </template>
    
  </v-expansion-panels>
      </field-form>
  <v-skeleton-loader v-else type="card@3">
  </v-skeleton-loader>  
</template>
<script>

import { mapState } from "vuex";
import FieldForm from "@/components/FieldForm"
import Wizards from "@/mixins/wizards"

export default {
    name: 'TrackingSkeleton',
    mixins: [Wizards],
    components: {FieldForm},
    data() {
        return {
            model: [],
            //switchWarning: false,
            //endpoint: 'domains',
            //fields: { leadscoringSettings: null, platform: null, capabilities: null, active: null },
            refreshing: false,
            panels: {
                'tracker': { index: 1, text: this.$t('overview.capabilities.tracker'), icon: '$visitors' },
                'viewProduct': {index: 2, text:this.$t('overview.capabilities.viewProduct'), icon: '$view' },
                'addToCart': { index: 3, text:this.$t('overview.capabilities.addToCart'), icon: '$cart' },
                'purchase': { index: 4, text:this.$t('overview.capabilities.purchase'), icon: '$purchase' },
                'signIn': { index: 5, text:this.$t('tracking.capabilities.signIn'), icon: '$signIn' },
            }
        };
    },
    props: {
        platform: {type: String, required: true },
        platformSettings: {type: Object, default: () => { return {}} },
        value: { type: Array },
        fails: {type: Array },
        saving: Boolean,
        allCode: { type: Array }
    },
    watch: {
        value(val) {
            this.model = val;
        },
        model(val) {
            this.$emit('input', val);
        },
        item() {
          this.evaluateFails();
        },
        platform() {
          this.evaluateFails();
        }
    },
    computed: {
        platformSettingsState() {
            if(!this.item) {
                return {
                    color: 'warn',
                    text: 'unknown',
                    icon: '$nok',
                    fail: true
                }
            }
            
            if(this.item.platform != this.platform) {
                return {
                    color: 'error',
                    text: this.$t('tracking.differentPlatform'),
                    icon: '$nok',
                    fail: true
                }
            }
            
            var res = Object.keys(this.platformSettings).every(i => this.platformSettings[i] == this.item.leadscoringSettings[i]);
            
            return {
                color: res ? 'success' : 'warning',
                text: res ? this.$t('tracking.correctPlatform') : this.$t('tracking.platformIncorrectParams'),
                icon: res ? '$ok' : '$warn',
                fail: !res
            }
        },
        ...mapState('domains', ['item'])
    },
    methods: {
        getCapabilityIcon(c) {
            return this.item.capabilities[c] ? '$ok' : '$nok';
        },
        getCapabilityColor(c) {
            return this.item.capabilities[c] ? 'success' : 'warning';
        },
        getCapabilityText(c) {
            return this.item.capabilities[c] ? this.$t('overview.capabilities.working') : this.$t('overview.capabilities.notWorking');
        },
        getCapabilityFail(c) {
            return !this.item.capabilities[c];
        },
        evaluateFails() {
          if(!this.item) {
            return;
          }
          var fails = Object.keys(this.panels).filter(p => { /* console.debug(`${p} : ${!this.item.capabilities[p]}`); */ return !this.item.capabilities[p] })
          //console.dir(this.platform);
          //console.dir(fails);
          
          if(this.platformSettingsState.fail) {
            fails.push('platformSettings');
          }
          this.$emit('update:fails', fails);
        },
        /*
        loadPanel(c, fail) {
            console.debug(`Panel ${c} loaded with fail ${fail}`);
        },
        */
       // TODO enable platform switch
        prepareSwitch() {
          this.fields.platform = this.platform;
          
          Object.keys(this.platformSettings).forEach(s => this.fields.leadscoringSettings[s] = this.platformSettings[s]);

          ['tracker','viewProduct','signIn','purchase','addToCart'].forEach(c => this.fields.capabilities[c] = false);
          this.fields.active = 'INCOMPLETE';
          this.switchWarning = true;
        },
        refresh() {
          this.refreshing = true;
          this.$store.dispatch('domains/get', {id: this.item.id }).then(() => {
            this.refreshing = false;
          });
        }
    },
    created() {
      this.evaluateFails();
    }
}
</script>